import { Link, useLocation } from "react-router-dom";

import AuthFormForgottenPassword from "../../components/Auth/AuthFormForgottenPassword";
import TemplateAuthentication from "../../components/UI/TemplateAuthentication";
import styles from "./ForgottenPassword.module.css";
import AuthHeader from "../../components/Auth/AuthHeader.tsx";

export default function ForgottenPassword() {
  const queryParams = new URLSearchParams(useLocation().search);
  let redirect = "";
  if (queryParams.get("redirect")) {
    redirect = "?redirect=" + queryParams.get("redirect");
  }

  return (
    <TemplateAuthentication>
      <AuthHeader title="Mot de passe oublié" />
      <AuthFormForgottenPassword />
      <div className={styles.links}>
        <Link to={redirect !== "" ? "/signup" + redirect : "../signup"}>
          Créer un compte
        </Link>
        <Link to={redirect !== "" ? "/" + queryParams.get("redirect") : "/"}>
          Se connecter
        </Link>
      </div>
    </TemplateAuthentication>
  );
}
